import Datatable from '../../dynamic/datatable/datatable';
import DataPortal from '../../dynamic/data-portal/data-portal';
import Chart from '../../dynamic/chart/chart';
import SpotlightReel from '../../dynamic/spotlight-reel/spotlight-reel';
import Searchbox from '../../simple/searchbox/searchbox';
import FacetsList from '../../dynamic/facets-list/facets-list';
import Accordion from '../../dynamic/accordion/accordion';
import Nav from '../../dynamic/nav/nav';
import Footer from '../../section/footer/footer';
import Header from '../../section/header/header';
import ResponsiveTables from '../../base/02-content/responsiveTable';
import Content from '../../base/02-content/content';
import Card from '../../simple/card/card';

//used for class to class interactions
let mainClasses = {
  Card,
  Content,
  FacetsList,
  Footer,
  Header,
  Nav,
  ResponsiveTables,
  Searchbox,
  SpotlightReel,
  Chart,
};

function init() {
  //used for class to class interactions
  let mainClassesInstances = {};

  for (const [key, value] of Object.entries(mainClasses)) {
    mainClassesInstances[key] = new value();
  }

  window.KB = {
    mainClasses,
    mainClassesInstances,
  };
}

document.addEventListener('DOMContentLoaded', init);

export default mainClasses;
